var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50039 13.2992C2.11539 13.2992 1.78592 13.1623 1.51199 12.8883C1.23806 12.6144 1.10086 12.2847 1.10039 11.8992V2.79922H0.400391V1.39922H3.90039V0.699219H8.10039V1.39922H11.6004V2.79922H10.9004V11.8992C10.9004 12.2842 10.7634 12.6139 10.4895 12.8883C10.2156 13.1627 9.88586 13.2997 9.50039 13.2992H2.50039ZM3.90039 10.4992H5.30039V4.19922H3.90039V10.4992ZM6.70039 10.4992H8.10039V4.19922H6.70039V10.4992Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cd6df0810b6a0c87f51c4b7e2dd0241e.svg";
export { ForwardRef as ReactComponent };